module.exports = __webpack_public_path__ + "static/media/solar.b64f75bf.png";